import type { LucideIcon } from "lucide-react";
import { DynamicIcon, iconNames, type IconName } from "lucide-react/dynamic";

const KNOWN_ICON_NAMES = new Set<string>(iconNames);

const isKnownIconName = (name: string): name is IconName => KNOWN_ICON_NAMES.has(name);

export interface AppIconProps {
  name: string;
  fallback: LucideIcon;
  className?: string;
}

/**
 * Renders a lucide-react icon by name (e.g. "chart-column") without bundling
 * every lucide icon — `DynamicIcon` lazy loads only the ones actually used.
 * Falls back to `fallback` for a name the backend sends that this build of
 * lucide doesn't recognize.
 */
export const AppIcon = ({ name, fallback: Fallback, className }: AppIconProps) => {
  if (!isKnownIconName(name)) {
    return <Fallback className={className} aria-hidden="true" />;
  }
  return <DynamicIcon name={name} className={className} aria-hidden="true" />;
};
